export default {
      id: "geozone-group-usage",
      viewBox: "0 0 31 22",
      url: __webpack_public_path__ + "img/icons.svg#geozone-group",
      toString: function () {
        return this.url;
      }
    }